// extracted by mini-css-extract-plugin
module.exports = {"container":"Clock_container__2qhTq","time":"Clock_time__1Xn3A","date":"Clock_date__tyvkD"};